// extracted by mini-css-extract-plugin
module.exports = {"label":"style-module_label__3Pf_vuVWFJ5UCqLJCLXCu2"};